<template>
	<div>
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="small-medium"
            @close="close"
            :hideFooter="true"
            v-if="isShowGenerateInvoice">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Generate Custom Invoice') }}</h5>
            </template>
            <template slot="body">
				<div>
					<form @submit.prevent="generateInvoice">
            <!-- email -->
            <div class="form-group mb-2">
              <label>{{ $t('Email') }}</label>
              <input type="bill_to_email" name="bill_to_email" class="form-control" v-model="bill_to_email" required>
              <span v-if="!isValidEmailAddress && bill_to_email !== ''" class="text-danger text-small">{{$t('Invalid Email Address')}}</span>
            </div>
            <!-- name -->
            <div class="form-group">
              <label>{{ $t('Fullname') }}</label>
              <input type="text" name="bill_to_name" class="form-control" v-model="bill_to_name" required>
            </div>
						<div class="d-flex">
							<!-- amount -->
							<div class="form-group col-md-6 ml-0 pl-0">
								<label>{{ $t('Amount') }}(USD)</label>
								<input type="number" name="amount" class="form-control" v-model="amount" required>
							</div>
							<!-- discount -->
							<div class="form-group col-md-6 ml-2 pl-2 mr-0 pr-0">
								<label>{{ $t('Discount (%)') }}</label>
								<input min=0 max=100 oninput="validity.valid||(value='');" type="number"  name="discount" class="form-control" v-model="discount">
							</div>
						</div>
						<div class="d-flex">
							<!-- date -->
							<div class="col-md-6 col-md-6 ml-0 pl-0">
								<div class="form-group">
									<label>{{ $t('Date Issued') }}</label>
									<flat-pickr
										class="date-event form-control"
										:config="configDateTimePicker"
										v-model="date"
									/>
								</div>
							</div>
							<div class="col-md-6 ml-2 pl-2 mr-0 pr-0">
								<div class="form-group roles">
									<label>{{ $t('Payment Method') }}</label>
									<multiselect class="roles-input" v-model="paymentMethod" tag-placeholder="Add Method"
										label="label" track-by="key"
										:options="paymentMethods"  :multiple="false" :searchable="false" :show-labels="false">
										<span class="arrow-multiselect" slot="caret">
											<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
										</span>
									</multiselect>
								</div>
							</div>
						</div>

						<!-- Description -->
						<div class="form-group">
							<label>{{ $t('Description') }}</label>
							<textarea type="text" name="description" rows="10" class="form-control" maxlength="455"
							v-model="description" required>
							</textarea>
						</div>

						<!-- Submit -->
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-secondary mt-3"
                :isDisabled="isSaving"
                @click="close"
              >
                {{ $t('Cancel') }}
              </button>
              <button
                :disabled="!isValid || isGenerateInvoice"
                :class="{'is-loading': isGenerateInvoice}"
                @click="preview()"
                class="btn btn-primary mt-3">
                {{ $t('Preview') }}
              </button>
            </div>
					</form>
				</div>
            </template>
            <div slot="footer" class="text-center">
            </div>
		</modal>

    <!-- preview -->
    <modal
      v-if="isPreview"
      class="swap-modal"
      size="large"
      @close="close"
      :hideFooter="true"
    >
      <template slot="header">
          <h5 class="mb-0">{{ $t('Generate Custom Invoice') }}</h5>
      </template>
      <template slot="body">
      <div>
        <preview-invoice
          v-if="isPreview"
          ref="previewModalInvoice"
          :invoice="generateParams"
          :invoiceNumber="invoiceNumber"
        />
        <!-- footer modal preview invoice -->
        <div class="relative">
          <div
            class="d-flex justify-content-between mx-4 mt-10"
          >
            <button
              class="btn btn-secondary mt-3"
              :isDisabled="isSaving"
              @click="isPreview = false"
            >
              {{ $t('Cancel') }}
            </button>
            <div>
              <button :disabled="!isValid || isSaving"
							:class="{'is-loading': isSaving}"
              @click="downloadPDF()"
							class="btn btn-danger mt-3 mr-3">
							{{ $t('Download') }} PDF
              </button>
              <button :disabled="!isValid || isSaving"
                :class="{'is-loading': isSaving}"
                @click="sendInvoice()"
                class="btn btn-primary mt-3">
                {{ $t('Generate & Send') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      </template>
    </modal>
	</div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import dayjs from 'dayjs';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import PreviewInvoice from '@/components/PreviewInvoice.vue';
import transactionsApi from '@/api/transactions';
import {
	isValidEmail,
	getAxiosErrorMessage,
} from '@/lib/helper';


export default {
	name: 'ModalGenerateInvoice',
	components: {
		Modal,
		Multiselect,
		flatPickr,
		PreviewInvoice,
	},
	props: {
		data: {
			type: Object,
			default: null,
		},
		isShowGenerateInvoice: {
			type: Boolean,
			default: false,
		},
	},
	mounted() {
	},
	data: () => ({
		userId: [],
		hover: false,
		hoverItem: null,
		isConfirmRemoveVisible: false,
		selected: '',
		isUnAssignUsers: false,
		isGenerateInvoice: false,
		configDateTimePicker: {
			enableTime: false,
			dateFormat: 'Y-m-d',
			minDate: 'today',
		},
		paymentMethod: { key: 'Bank Transfer', label: 'Bank Transfer' },
		description: '',
		date: dayjs(new Date()).format('YYYY-MM-DD'),
		discount: 0,
		amount: '',
		paymentMethods: [
			{ key: 'Bank Transfer', label: 'Bank Transfer' },
			{ key: 'Cash', label: 'Cash' },
			{ key: 'Others', label: 'Others' },
		],
		bill_to_email: null,
		bill_to_name: null,

		// preview
		isPreview: false,
		readyToSent: false,
		invoiceId: null,
		invoiceNumber: '',
		isSaving: false,
	}),

	methods: {
		close() {
			this.$emit('close');
		},
		reset() {
			this.amount = '';
			this.discount = '';
			this.date = '';
			this.paymentMethod = '';
			this.description = '';
		},
		downloadPDF() {
			this.$refs.previewModalInvoice.downloadPDF();
		},
		sendInvoice() {
			this.isSaving = true;
			const callback = (response) => {
				const message = response.message;
				this.isSaving = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Users',
					text: message,
				});
				this.closeInvoice();
			};
			const errorCallback = (error) => {
				const message = error.response.data.message;
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isSaving = false;
			};
			transactionsApi.sendInvoice(this.invoiceId, callback, errorCallback);
		},
		generate() {
			this.isGenerateInvoice = true;
			const callback = (response) => {
				this.isGenerateInvoice = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Users',
					text: response.message,
				});
				this.invoiceId = response.data.id;
				this.invoiceNumber = response.data.invoice_number;
				this.isGenerateInvoice = false;
				this.isPreview = true;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isGenerateInvoice = false;
			};
			transactionsApi.generateInvoice(this.generateParams, callback, errorCallback);
		},
		closeInvoice() {
			this.isPreview = false;
			this.invoiceId = null;
			this.invoiceNumber = '';
			this.$emit('close');
		},
		preview() {
			this.generate();
		},
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'isLoggedIn',
		}),

		isValidEmailAddress() {
			return isValidEmail(this.bill_to_email);
		},

		generateParams() {
			const params = {
				amount: this.amount,
				discount: this.discount,
				date: this.date,
				payment_method: this.paymentMethod && this.paymentMethod.key ? this.paymentMethod.key : '',
				description: this.description,
				user_id: this.userId,
				bill_to_email: this.bill_to_email,
				bill_to_name: this.bill_to_name,
			};
			return params;
		},
		isValid() {
			return 	this.amount !== ''
			&& this.date !== ''
			&& this.paymentMethod && this.paymentMethod.length !== 0
			&& this.isValidEmailAddress
			&& this.bill_to_name !== '';
		},
	},
	created() {
		if (this.data) {
			if (this.data && this.data.id) {
				this.userId.push(this.data && this.data.id ? this.data.id : null);
				this.bill_to_email = this.data && this.data.email ? this.data.email : null;
				this.bill_to_name = this.data && this.data.name ? this.data.name : null;

				// Get current date
				const currentDate = new Date();
				// Extract year, month, and day
				const year = currentDate.getFullYear();
				const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based
				const day = String(currentDate.getDate()).padStart(2, '0');
				// Form the YYYY-MM-DD format
				const formattedDate = `${year}-${month}-${day}`;
				this.date = formattedDate;

				// re init data amount discount & description
				this.description = '';
				this.amount = '';
				this.discount = 0;
			}
		}
	},
	watch: {
	},
};
</script>

<style>
.assigned-user-modal{
	min-height: 500px!important;
}
</style>
